import React, { useState, useEffect, useRef } from "react";

import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import TabsOrAccordion from "./TabAcordion";
const AmigoFarma = () => {
  const inputRef = useRef(null);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  const [textoBusca, setTextoBusca] = useState("");
  const [sugestoes, setSugestoes] = useState([]);
  const [produtoSelecionado, setProdutoSelecionado] = useState("");
  const [resultado, setResultado] = useState(null);
  const [carregando, setCarregando] = useState(false);
  const [tabAtiva, setTabAtiva] = useState("itensComplemento");
  const navigate = useNavigate();
  const [complementaresCarregando, setComplementaresCarregando] = useState(false);
const [complementaresComEstoque, setComplementaresComEstoque] = useState([]);
const [intercambiaveisCarregando, setIntercambiaveisCarregando] = useState(false);
const [intercambiaveisComEstoque, setIntercambiaveisComEstoque] = useState([]);
  const matriculaSession = sessionStorage.getItem("matricula");
  const matricula = matriculaSession ? JSON.parse(matriculaSession).username : null;

  useEffect(() => {
    const buscarEstoque = async () => {
      let itens = [];
  
      if (typeof resultado?.intercambiaveis === "string") {
        itens = resultado.intercambiaveis
          .split(",")
          .map((item) => item.trim())
          .filter((item) => item);
      } else if (Array.isArray(resultado?.intercambiaveis)) {
        itens = resultado.intercambiaveis;
      }
  
      if (tabAtiva === "intercambiaveis" && itens.length > 0) {
        setIntercambiaveisCarregando(true);
        try {
          const res = await axios.post("https://fsys.app.br/5dx/verificarEstoque.php", {
            itens
          });
          setIntercambiaveisComEstoque(res.data);
        } catch (err) {
          console.error("Erro ao buscar estoque dos intercambiáveis:", err);
          setIntercambiaveisComEstoque([]);
        } finally {
          setIntercambiaveisCarregando(false);
        }
      }
    };
  
    buscarEstoque();
  }, [resultado]);
  
  useEffect(() => {
    const buscarEstoque = async () => {
      console.log("buscarEstoque", resultado?.itensComplemento?.length)
      if (resultado?.itensComplemento?.length > 0) {
        setComplementaresCarregando(true);
        try {
          const res = await axios.post("https://fsys.app.br/5dx/verificarEstoque.php", {
            itens: resultado.itensComplemento,
          });
          setComplementaresComEstoque(res.data);
        } catch (err) {
          console.error("Erro ao buscar estoque de itens complementares:", err);
          setComplementaresComEstoque([]);
        } finally {
          setComplementaresCarregando(false);
        }
      }
    };
  
    buscarEstoque();
  }, [resultado]);
  
  useEffect(() => {
    const delay = setTimeout(() => {
      if (textoBusca.length >= 2 && !carregando) {
        buscarSugestoes(textoBusca);
      } else {
        setSugestoes([]);
      }
    }, 300);
    return () => clearTimeout(delay);
  }, [textoBusca, carregando]);
  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/");
  };
  const [ofertando, setOfertando] = useState(null); // ID do item sendo salvo (opcional)
const salvarProdutoOfertado = async (item) => {
  try {
    setOfertando(item.item); // mostra loading opcionalmente por item
    await axios.post("https://fsys.app.br/5dx/salvarProdutoOfertado.php", {
      produto: item.item,
      codigo: item.codigo,
      estoque: item.estoque,
      preco: item.preco,
      motivo: item.motivo,
      matricula: matricula
    });
     Swal.fire({
              title: 'Sucesso!',
              text: item.item + " salvo como ofertado com sucesso!",
              icon: 'success',
              timer: 2000,
            showConfirmButton: false,
            });
   // alert(`Produto "${item.item}" salvo como ofertado com sucesso.`);
  } catch (err) {
    console.error("Erro ao salvar produto ofertado:", err);
  //  alert("Erro ao salvar produto ofertado.");
  } finally {
    setOfertando(null);
  }
};
  const buscarSugestoes = async (texto) => {
    try {
      const res = await axios.get(`https://fsys.app.br/5dx/buscar_produtos.php?q=${encodeURIComponent(texto)}`);
      setSugestoes(res.data);
    } catch (err) {
      console.error("Erro ao buscar sugestões:", err);
    }
  };

  const enviarProduto = async (nomeSelecionado = "") => {
    let nomeFinal = nomeSelecionado || produtoSelecionado || textoBusca.trim();
    if (!nomeFinal) return alert("Digite o nome de um produto.");
  
    setCarregando(true);
    setResultado(null);
    setSugestoes([]);
  
    try {
      // Se for código de barras (ex: 13 dígitos numéricos)
      if (/^\d{13}$/.test(nomeFinal)) {
        const resCodigo = await axios.get(
          `https://fsys.app.br/5dx/buscar_produtos.php?q=${encodeURIComponent(nomeFinal)}`
        );
  
        if (resCodigo.data && resCodigo.data.length > 0) {
          nomeFinal = resCodigo.data[0].nome; // Pega o nome do primeiro resultado
          setTextoBusca(nomeFinal);
        } else {
          alert("Produto não encontrado para o código de barras informado.");
          return;
        }
      }
  // Recupera a matrícula da sessionStorage
      const matriculaSession = sessionStorage.getItem("matricula");
      const matricula = matriculaSession ? JSON.parse(matriculaSession).username : null;
      const formData = new FormData();
      formData.append("produto", nomeFinal);
      formData.append("matricula", matricula); // <-- Adiciona a matrícula aqui

      const res = await axios.post("https://fsys.app.br/5dx/amigoFarmaHomo.php", formData);
      console.log("felipe", res.data);
      setResultado(res.data);
      setTabAtiva("itensComplemento");
    } catch (err) {
      console.error("Erro ao consultar:", err);
      alert("Erro ao consultar o produto.");
    } finally {
      setCarregando(false);
      setTextoBusca("");
    }
  };
  

  return (
    <div className="container py-4">
      <h5 style={{position: 'fixed', top: 0, right: 16, fontSize: 12}}
>Matricula: {matricula} - <button onClick={handleLogout} className="btn btn-sm btn-danger">sair</button>
</h5>
      <h4 style ={{fontSize: 14}}>🔍 Consultar Produto no Amigo Farma</h4>

      <div className="input-group mt-3">
  <input
    type="text"
    className="form-control"
    placeholder="Digite o nome do produto"
    ref={inputRef} // <-- aqui!
    disabled={carregando}
    value={textoBusca}
    onChange={(e) => {
      setTextoBusca(e.target.value);
      setProdutoSelecionado("");
    }}
    onKeyDown={(e) => {
      if (e.key === "Enter") enviarProduto();
    }}
  />
  <button
    className="btn btn-success"
    disabled={carregando}
    onClick={() => enviarProduto()}
  >
    {carregando ? "Consultando..." : "Consultar"}
  </button>
</div>

      {/* Autocomplete */}
      {!carregando && sugestoes.length > 0 && textoBusca !== produtoSelecionado && (
        <ul className="list-group mt-2">
          {sugestoes.map((sug, index) => (
            <li
              key={index}
              className="list-group-item list-group-item-action"
              onClick={() => {
                setProdutoSelecionado(sug.nome);
                setTextoBusca(sug.nome);
                setSugestoes([]);
                enviarProduto(sug.nome);
              }}
              style={{ cursor: "pointer" }}
            >
              {sug.nome}
            </li>
          ))}
        </ul>
      )}

     

      {resultado && (
        <div style={{marginTop: 10}}>
          <h4 className="mb-4">{resultado.productName}</h4>
<TabsOrAccordion
  resultado={resultado}
  tabAtiva={tabAtiva}
  setTabAtiva={setTabAtiva}
  conteudoTabs={{
    itensComplemento: resultado.itensComplemento?.length > 0 && {
      label: "💵 Itens Complementares",
      component: (
        <>
          {complementaresCarregando ? (
            <div className="text-center my-3">
              <div className="spinner-border text-primary" role="status" />
              <p>Verificando estoque dos itens...</p>
            </div>
          ) : complementaresComEstoque.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-bordered mt-3">
                <thead>
                  <tr>
                    <th>P.A.</th>
                    <th>Codigo</th>
                    <th>Item</th>
                    {/* <th>Estoque</th> */}
                    <th>Preço</th>
                    <th>Motivo</th>
                    <th>Ação</th>
                  </tr>
                </thead>
                <tbody>
                  {complementaresComEstoque.map((item, i) => (
                    <tr key={i}>
                      <td>{item.pa}</td>
                      <td>{item.codigo}</td>
                      <td>{item.item}</td>
                      {/* <td>{item.estoque}</td> */}
                      <td>R$ {parseFloat(item.preco).toFixed(2)}</td>
                      <td>{item.motivo}</td>
                      <td>
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => salvarProdutoOfertado(item)}
                          disabled={ofertando === item.item}
                        >
                          {ofertando === item.item ? "Salvando..." : "Produto ofertado"}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p>Nenhum item complementar com estoque disponível.</p>
          )}
        </>
      ),
    },
    intercambiaveis: resultado.intercambiaveis?.length > 0 && {
      label: "🔁 Intercambiáveis",
      component: (
        <>
          {intercambiaveisCarregando ? (
            <div className="text-center my-3">
              <div className="spinner-border text-primary" role="status" />
              <p>Verificando estoque dos intercambiáveis...</p>
            </div>
          ) : intercambiaveisComEstoque.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-bordered mt-3">
                <thead>
                  <tr>
                    <th>P.A.</th>
                    <th>Codigo</th>
                    <th>Item</th>
                    <th>Estoque</th>
                    <th>Preço</th>
                    <th>Ação</th>
                  </tr>
                </thead>
                <tbody>
                  {intercambiaveisComEstoque.map((item, i) => (
                    <tr key={i}>
                      <td>{item.pa}</td>
                      <td>{item.codigo}</td>
                      <td>{item.item}</td>
                      <td>{item.estoque}</td>
                      <td>R$ {parseFloat(item.preco).toFixed(2)}</td>
                      <td>
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => salvarProdutoOfertado(item)}
                          disabled={ofertando === item.item}
                        >
                          {ofertando === item.item ? "Salvando..." : "Produto ofertado"}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p>Nenhum intercambiável com estoque disponível.</p>
          )}
        </>
      ),
    },
  
    posologia: resultado.posologia && {
      label: "📝 Posologia",
      component: <p><strong>Posologia:</strong> {resultado.posologia}</p>,
    },
    indicacoes: resultado.indicacoes && {
      label: "📌 Indicações",
      component: <p><strong>Indicações:</strong> {resultado.indicacoes}</p>,
    },
    contraIndicacoes: resultado.contraIndicacoes && {
      label: "🚫 Contraindicações",
      component: <p><strong>Contraindicações:</strong> {resultado.contraIndicacoes}</p>,
    },
    efeitosColaterais: resultado.efeitosColaterais && {
      label: "⚠️ Efeitos Colaterais",
      component: <p><strong>Efeitos Colaterais:</strong> {resultado.efeitosColaterais}</p>,
    },
    modoAdministracao: resultado.modoAdministracao && {
      label: "🧭 Administração",
      component: <p><strong>Modo de Administração:</strong> {resultado.modoAdministracao}</p>,
    },
    precaucoesUso: resultado.precaucoesUso && {
      label: "🛡️ Precauções",
      component: <p><strong>Precauções de Uso:</strong> {resultado.precaucoesUso}</p>,
    },
    interacoesMedicamentosas: resultado.interacoesMedicamentosas && {
      label: "🔁 Interações",
      component: <p><strong>Interações Medicamentosas:</strong> {resultado.interacoesMedicamentosas}</p>,
    },
    principioAtivo: resultado.principioAtivo && {
      label: "💊 Princípio Ativo",
      component: <p><strong>Princípio Ativo:</strong> {resultado.principioAtivo}</p>,
    },
    // usoGestantes: resultado.usoGestantes && {
    //   label: "🤰 Gestantes",
    //   component: <p><strong>Uso em Gestantes/Lactantes:</strong> {resultado.usoGestantes}</p>,
    // },
    // tipoVenda: resultado.tipoVenda && {
    //   label: "🛒 Tipo de Venda",
    //   component: <p><strong>Tipo de Venda:</strong> {resultado.tipoVenda}</p>,
    // },
    // tipoReceita: resultado.tipoReceita && {
    //   label: "📄 Receita",
    //   component: <p><strong>Tipo de Receita:</strong> {resultado.tipoReceita}</p>,
    // },
  }}
/>

          </div>
      
      )}
       
       <div>

       <span style={{fontSize: 12}}>*Consulte um profissional de saúde antes de realizar qualquer substituição ou indicação medicamentosa</span>
       </div>
    </div>
  );
};

export default AmigoFarma;
